import {TableCell, TableRow} from "@material-ui/core";
import WorkableIconDeleteButton from "components/button/WorkableIconDeleteButton";
import React from "react";
import getObjectValue from "libs/getObjectValue";
import { LABELS } from "../constants/AuditTaskAllowedObjectType"


function AuditTaskAllowedObjectRow({
    id,
    index,
    formikProps,
    taskId,
    deleteAllowedObject,
    editable
}) {

    const formId = `${id}.${index}`;
    const allowedObject = getObjectValue(formId, formikProps.values, {});

    return (
        <TableRow>
            <TableCell>{LABELS[allowedObject.objectType]}</TableCell>
            <TableCell>{allowedObject.objectNumber}</TableCell>
            <TableCell>{allowedObject.objectName}</TableCell>
            <TableCell>{allowedObject.objectStatus}</TableCell>
            <TableCell>
                {editable && <WorkableIconDeleteButton onClick={() => deleteAllowedObject(index)} />}
            </TableCell>
        </TableRow>
    )
}

export default AuditTaskAllowedObjectRow;